<p-panelMenu class="sidebar-panel-menu" [multiple]="isMultipleTabOpen" [model]="items"></p-panelMenu>